import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { METHANOL_STATUS_CONFIG } from "../../utils/methanolStatusConfig";
import HistoryBreakdownPanel from "../history/HistoryBreakdownPanel";
const DEFAULT_FALLBACK_COLOR = "#808080";
const DEFAULT_EMPTY_TEXT = "No data available";
const DEFAULT_RIGHT_COLUMN_HEADER = "Hours";
const DEFAULT_TITLE = "Status History";
const DEFAULT_LEFT_COLUMN_HEADER = "Status";
const DEFAULT_MAX_TABLE_HEIGHT = "350px";
const DEFAULT_UNIT = "hours";
const ERROR_MESSAGE_LOAD_FAILED = "Failed to load status history.";
// Default display order matches the Figma badge order
const DEFAULT_DISPLAY_ORDER = [
    "charging",
    "lowpressure",
    "producing",
    "production",
    "warming",
    "cooling",
    "cooldown",
    "move",
    "fault",
    "off",
    "idle",
    "maintenance",
    "online",
    "hotstandby",
    "coldstandby",
    "preparingforstandby",
    "standby"
];
const MethanolReformerStatusHistory = ({ assetId, chartSize, displayOrder = DEFAULT_DISPLAY_ORDER, emptyText = DEFAULT_EMPTY_TEXT, isError = false, isLoading = false, projectId, restrictToDisplayOrder = false, rightColumnHeader = DEFAULT_RIGHT_COLUMN_HEADER, statusConfig = METHANOL_STATUS_CONFIG, statusHistory, title = DEFAULT_TITLE }) => {
    const isWaitingForData = !assetId || !projectId;
    const loading = isWaitingForData || isLoading;
    const statusEntries = useMemo(() => {
        if (!statusHistory || statusHistory.length === 0)
            return [];
        // Build a lookup from the response — normalise casing and whitespace
        const durationByKey = {};
        statusHistory.forEach((entry) => {
            const key = entry.assetStatus.toLowerCase().replace(/\s+/g, "");
            durationByKey[key] = (durationByKey[key] ?? 0) + entry.duration;
        });
        // Only include statuses actually received from the backend, in display order.
        // When restrictToDisplayOrder is true, only show statuses in the displayOrder list.
        const orderedKeys = displayOrder.filter((key) => key in durationByKey);
        const extraKeys = restrictToDisplayOrder
            ? []
            : Object.keys(durationByKey).filter((key) => !displayOrder.includes(key));
        const entries = [...orderedKeys, ...extraKeys]
            .map((key) => {
            const config = statusConfig[key];
            return {
                color: config?.color ?? DEFAULT_FALLBACK_COLOR,
                key,
                label: config?.label ?? key.charAt(0).toUpperCase() + key.slice(1),
                value: durationByKey[key]
            };
        })
            .filter((entry) => entry.value > 0);
        return entries;
    }, [statusHistory, displayOrder, statusConfig, restrictToDisplayOrder]);
    return (_jsx("div", { className: "flex flex-col h-full", "data-test": "methanol-reformer-status-history", children: _jsx(HistoryBreakdownPanel, { chartSize: chartSize, "data-test": "status-history", emptyText: emptyText, error: isError ? ERROR_MESSAGE_LOAD_FAILED : undefined, leftColumnHeader: DEFAULT_LEFT_COLUMN_HEADER, loading: loading, maxTableHeight: DEFAULT_MAX_TABLE_HEIGHT, metrics: statusEntries, rightColumnHeader: rightColumnHeader, title: title, unit: DEFAULT_UNIT }) }));
};
export default MethanolReformerStatusHistory;
